<template>
  <div id="app" class="wrapper">
    <Header />
    <router-view />
    <Footer />
    <a href="javascript:void(0)" class="scroll-top on">
      <span class="screen-reader-text">Go to Top</span>
    </a>
  </div>
</template>
<script>
import { includes } from 'lodash'
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'App',
  components: {
    Footer,
    Header
  },
  data: () => ({
    excludes: ['videoLibrary', 'video', 'home']
  }),
  watch: {
    $route: {
      handler(val) {
        if (!includes(this.excludes, val.name)) {
          this.$store.dispatch('hideLoader')
        }
      },
      immediate: true
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchVideos')
  }
}
</script>
<style lang="scss">
.toasted-container {
  &.top-right {
    right: 0 !important;
    .toasted {
      background-color: #2ba048;
      width: 100%;
      padding: 15px;
    }
  }
}
</style>
